import wolishoLogo from '../assets/logos/wolisho.svg';

import { Layout } from './Layout';

interface SignedOutLandingProps {
  onLogin: () => void;
}

export function SignedOutLanding({ onLogin }: SignedOutLandingProps) {
  return (
    <Layout>
      <div
        className="flex min-h-full flex-col items-center justify-center gap-5 px-6 py-12 text-center"
        data-testid="signed-out-landing"
      >
        <img src={wolishoLogo} alt="Wolisho" className="h-8" />
        <div>
          <h1 className="text-xl font-bold text-black mb-1.5">
            Find your next unforgettable sip
          </h1>
          <p className="text-sm text-black/60">
            Log in to save coffees, rate your sips, and see what others are
            drinking.
          </p>
        </div>
        <button
          type="button"
          onClick={onLogin}
          className="bg-wolisho-red text-white font-bold text-base rounded-lg px-10 py-3.5 hover:opacity-90 transition-opacity"
          data-testid="signed-out-login"
        >
          Log in
        </button>
      </div>
    </Layout>
  );
}
